import React, { CSSProperties } from "react";
import "./CanvasDebugger.scss";
import { Tabs, Tab, PersistentTabPanel } from "../../shared/components";
import MetadataTab from "./Metadata";
import TemplatesTab from "./Templates";
import FrameDataTab from "./FrameData";
import ParameterValuesTab from "./ParameterValues";
import { Canvas } from "../../store/storyline/types";
import Traces from "./Traces";
import VsCode from "./VsCode";
import * as _ from "lodash";
import Datasources from "./Datasources";
import { usePopoutWindowContext } from "../../shared/components/PopoutWindow";

interface CanvasDebuggerProps {
    slide: Canvas,
    frameData: object;
}

function CanvasDebugger(props: CanvasDebuggerProps) {
    const { slide, frameData } = props;
    const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
    // The editor controls do not enjoy being used in a semi-headless state, so we add a small artificial delay between initial pop-up window render
    // and the time the editor is shown...
    const [loading, setLoading] = React.useState(true);
    const popoutWindowContext = usePopoutWindowContext();

    React.useEffect(() => {
        setTimeout(() => {
            setLoading(false);
            // After all the controls are rendered, pull the new dynamic styles from the parent window...
            setTimeout(() => popoutWindowContext.pullStylesFromParentWindow(), 500);
        }, 100);
    }, []);

    const handleTabChange = React.useCallback((_event: React.ChangeEvent<{}>, newSelectedIndex: number) => {
        setSelectedTabIndex(newSelectedIndex);
    }, [setSelectedTabIndex]);

    if (!slide) return null;

    return (
        <div className="canvas-debugger">
            {
                loading ?
                    <div className="screen-centered">Initializing...</div> :
                    <>
                        <Tabs
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile={true}
                            value={selectedTabIndex}
                            onChange={handleTabChange}
                        >
                            <Tab label="Metadata" />
                            <Tab label="Templates" />
                            <Tab label="Frame Data" />
                            <Tab label="Parameter Values" />
                            <Tab label="Datasources" />
                            <Tab label="Event Log" />
                            <Tab label="VS Code" />
                        </Tabs>

                        <PersistentTabPanel key="tab-0" selectedValue={selectedTabIndex} value={0}>
                            <MetadataTab slide={slide} />
                        </PersistentTabPanel>

                        <PersistentTabPanel key="tab-1" selectedValue={selectedTabIndex} value={1}>
                            <TemplatesTab currentPageTemplate={slide.templateName} />
                        </PersistentTabPanel>

                        <PersistentTabPanel key="tab-2" selectedValue={selectedTabIndex} value={2}>
                            <FrameDataTab frameData={frameData} />
                        </PersistentTabPanel>

                        <PersistentTabPanel key="tab-3" selectedValue={selectedTabIndex} value={3}>
                            <ParameterValuesTab />
                        </PersistentTabPanel>

                        <PersistentTabPanel key="tab-4" selectedValue={selectedTabIndex} value={4}>
                            <Datasources />
                        </PersistentTabPanel>

                        <PersistentTabPanel key="tab-5" selectedValue={selectedTabIndex} value={5}>
                            <Traces />
                        </PersistentTabPanel>

                        <PersistentTabPanel key="tab-6" selectedValue={selectedTabIndex} value={6}>
                            <VsCode />
                        </PersistentTabPanel>
                    </>
            }
        </div>
    );
}

export default CanvasDebugger;